/* =====================================================
   NUTTY & NOSTALGIC — main.js
   ===================================================== */

(function () {
  'use strict';

  /* ---- Mobile nav ---- */
  const toggle   = document.getElementById('nav-toggle');
  const close    = document.getElementById('nav-close');
  const nav      = document.getElementById('mobile-nav');
  const backdrop = document.getElementById('nav-backdrop');
  let scrollY    = 0;

  function openNav() {
    scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    backdrop.classList.add('is-visible');
    toggle.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    close.focus();
  }

  function closeNav() {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    backdrop.classList.remove('is-visible');
    toggle.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
    toggle.focus();
  }

  toggle.addEventListener('click', openNav);
  close.addEventListener('click', closeNav);
  backdrop.addEventListener('click', closeNav);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) closeNav();
  });

  /* ---- Channel flip: start animation on scroll into view ---- */
  const flipSection = document.querySelector('.channel-flip');
  if (flipSection) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('is-visible');
      });
    }, { threshold: 0.25 }).observe(flipSection);
  }

  /* ---- TV section: OG → jar wipe when product reaches viewport center ---- */
  const tvSection = document.querySelector('.tv-section');
  if (tvSection) {
    const tvPairs = Array.from(tvSection.querySelectorAll('.tv-pair'));
    let tvRafId = null;

    function checkTvCenter() {
      const cx = window.innerWidth / 2;
      tvPairs.forEach(function (pair) {
        const r = pair.getBoundingClientRect();
        const pairCx = r.left + r.width / 2;
        if (Math.abs(pairCx - cx) < r.width * 0.35) {
          pair.classList.add('is-transforming');
        } else if (r.right < 0) {
          pair.classList.remove('is-transforming');
        }
      });
      tvRafId = requestAnimationFrame(checkTvCenter);
    }

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!tvRafId) tvRafId = requestAnimationFrame(checkTvCenter);
          } else {
            if (tvRafId) { cancelAnimationFrame(tvRafId); tvRafId = null; }
          }
        });
      }, { threshold: 0 }).observe(tvSection);
    }
  }

  /* ---- Master Tapes: VHS comparison slider ---- */
  (function () {
    var screen   = document.getElementById('tape-screen');
    if (!screen) return;

    var ogLayer  = document.getElementById('tape-og');
    var ogImg    = document.getElementById('tape-og-img');
    var jarImg   = document.getElementById('tape-jar-img');
    var grip     = document.getElementById('tape-grip');
    var staticEl = document.getElementById('tape-static');
    var range    = document.getElementById('tape-range');
    var buttons  = Array.from(document.querySelectorAll('.tape-btn'));

    var TAPES = [
      { og: NN_ASSET_BASE + 'pb-max.png',        jar: NN_ASSET_BASE + 'pb-max-d-transparent.png',        bg: '#f0d8ca' },
      { og: NN_ASSET_BASE + 'pb-crisps.png',      jar: NN_ASSET_BASE + '90s-crisps-transparent.png',      bg: '#d5ddf0' },
      { og: NN_ASSET_BASE + 'turtle-pies.png',     jar: NN_ASSET_BASE + 'cowabunga-pies-transparent.png',  bg: '#d0e8d5' },
      { og: NN_ASSET_BASE + 'butterfinger-bbs.png', jar: NN_ASSET_BASE + 'nuttyfinger-bbs-transparent.png', bg: '#eeddcc' },
      { og: NN_ASSET_BASE + 'kudos-bar.png',       jar: NN_ASSET_BASE + 'granola-bar-transparent.png',     bg: '#f0e8c5' }
    ];

    var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var currentTape = 0;
    var wipe = 35;
    var dragging = false;
    var rafId = null;
    var pendingWipe = null;

    function setWipe(pct) {
      wipe = Math.min(98, Math.max(2, pct));
      screen.style.setProperty('--wipe', wipe + '%');
      range.value = wipe;
    }

    function scheduleWipe(clientX) {
      var rect = screen.getBoundingClientRect();
      pendingWipe = ((clientX - rect.left) / rect.width) * 100;
      if (!rafId) rafId = requestAnimationFrame(flushWipe);
    }

    function flushWipe() {
      rafId = null;
      if (pendingWipe !== null) { setWipe(pendingWipe); pendingWipe = null; }
    }

    screen.addEventListener('pointerdown', function (e) {
      dragging = true;
      screen.setPointerCapture(e.pointerId);
      scheduleWipe(e.clientX);
    });

    screen.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      scheduleWipe(e.clientX);
    });

    screen.addEventListener('pointerup',     function () { dragging = false; });
    screen.addEventListener('pointercancel', function () { dragging = false; });

    range.addEventListener('input', function () {
      setWipe(parseFloat(range.value));
    });

    range.addEventListener('focus', function () { grip.classList.add('has-focus'); });
    range.addEventListener('blur',  function () { grip.classList.remove('has-focus'); });

    function animateTo(target, ms) {
      var start = wipe;
      var t0 = performance.now();
      function step(now) {
        var t = Math.min(1, (now - t0) / ms);
        setWipe(start + (target - start) * (1 - Math.pow(1 - t, 2)));
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    function loadTape(i) {
      var tape = TAPES[i];
      ogImg.src  = tape.og;
      jarImg.src = tape.jar;
      screen.style.setProperty('--tape-og-bg', tape.bg);
    }

    function switchTape(i) {
      if (i === currentTape) return;
      currentTape = i;
      buttons.forEach(function (btn, idx) {
        btn.classList.toggle('is-active', idx === i);
        btn.setAttribute('aria-pressed', idx === i ? 'true' : 'false');
      });

      if (rm) {
        ogLayer.style.transition = 'opacity .12s';
        ogLayer.style.opacity = '0';
        setTimeout(function () {
          loadTape(i);
          ogLayer.style.opacity = '1';
        }, 80);
        return;
      }

      staticEl.classList.add('is-active');
      setTimeout(function () { loadTape(i); }, 90);
      setTimeout(function () { staticEl.classList.remove('is-active'); }, 190);
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        switchTape(parseInt(btn.dataset.tape, 10));
      });
    });

    /* Preload all images after first paint */
    window.addEventListener('load', function () {
      TAPES.forEach(function (t) {
        [t.og, t.jar].forEach(function (src) {
          var img = new Image();
          img.src = src;
        });
      });
    });

    /* Nudge affordance on first scroll into view */
    var nudged = false;
    new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !nudged) {
        nudged = true;
        if (!rm) {
          setTimeout(function () {
            animateTo(45, 450);
            setTimeout(function () { animateTo(35, 450); }, 450);
          }, 500);
        }
      }
    }, { threshold: 0.4 }).observe(screen);
  }());

  /* ---- Reduced-motion: pause video when it exists ---- */
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function applyMotion(mq) {
    document.querySelectorAll('video[autoplay]').forEach(function (v) {
      mq.matches ? v.pause() : v.play().catch(function () {});
    });
  }

  motionQuery.addEventListener('change', applyMotion);
  applyMotion(motionQuery);

})();

/* =====================================================
   PRODUCT PAGE — bundle selector, gallery, sticky ATC
   ===================================================== */
(function () {
  'use strict';

  var buy = document.querySelector('.pdp-buy');
  if (!buy) return;

  /* Gallery slideshow */
  var track = document.getElementById('pdp-track');
  if (track) {
    var slides = track.children.length;
    var dots = Array.from(document.querySelectorAll('.pdp-dot'));
    var index = 0;

    function go(i) {
      index = (i + slides) % slides;
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
    }

    var prev = document.getElementById('pdp-prev');
    var next = document.getElementById('pdp-next');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });

    /* Touch swipe */
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  /* Quantity stepper */
  var qtyVal = document.getElementById('qty-val');
  var qtyMinus = document.getElementById('qty-minus');
  var qtyPlus = document.getElementById('qty-plus');
  if (qtyVal && qtyMinus && qtyPlus) {
    var qty = 1;
    function setQty(n) { qty = Math.max(1, Math.min(99, n)); qtyVal.textContent = qty; }
    qtyMinus.addEventListener('click', function () { setQty(qty - 1); });
    qtyPlus.addEventListener('click', function () { setQty(qty + 1); });
  }

  /* Before / after comparison slider */
  var ba = document.getElementById('ba');
  if (ba) {
    var baRange = document.getElementById('ba-range');
    var baDrag = false, baRaf = null, baPending = null;

    function baSet(pct) {
      pct = Math.max(2, Math.min(98, pct));
      ba.style.setProperty('--split', pct + '%');
      /* Each word fades in as its side is dragged open past center */
      ba.style.setProperty('--orig-op', Math.max(0, Math.min(1, (pct - 50) / 38)));
      ba.style.setProperty('--remade-op', Math.max(0, Math.min(1, (50 - pct) / 38)));
      if (baRange) baRange.value = pct;
    }
    function baFromX(clientX) {
      var r = ba.getBoundingClientRect();
      return ((clientX - r.left) / r.width) * 100;
    }
    function baFlush() { baRaf = null; if (baPending !== null) { baSet(baPending); baPending = null; } }
    function baSched(clientX) { baPending = baFromX(clientX); if (!baRaf) baRaf = requestAnimationFrame(baFlush); }

    ba.addEventListener('pointerdown', function (e) { baDrag = true; ba.setPointerCapture(e.pointerId); baSched(e.clientX); });
    ba.addEventListener('pointermove', function (e) { if (baDrag) baSched(e.clientX); });
    ba.addEventListener('pointerup', function () { baDrag = false; });
    ba.addEventListener('pointercancel', function () { baDrag = false; });
    if (baRange) baRange.addEventListener('input', function () { baSet(parseFloat(baRange.value)); });
  }

  /* Sticky mobile ATC — show after the buy box scrolls out */
  var sticky = document.getElementById('pdp-sticky');
  var atc = document.querySelector('.pdp-atc');
  if (sticky && atc) {
    new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      // lift the hotline launcher above the sticky bar so they don't overlap (mobile).
      // Look it up here, not at setup — the hotline markup is parsed AFTER main.js.
      var hotlineBtn = document.getElementById('nn-hotline-open');
      if (hotlineBtn) hotlineBtn.classList.toggle('nn-hotline--lifted', show);
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(atc);
  }
})();

/* =====================================================
   ABOUT: Cancelled → Revived flip cards (tap on touch)
   ===================================================== */
(function () {
  'use strict';
  var cards = document.querySelectorAll('.revive-card');
  if (!cards.length) return;
  cards.forEach(function (card) {
    card.addEventListener('click', function () { card.classList.toggle('is-flipped'); });
    var back = card.querySelector('.revive-card__back');
    if (back) back.addEventListener('click', function (e) { e.stopPropagation(); });
  });
})();

/* =====================================================
   FOOTER: REWIND — fast scroll to top with static flicker
   ===================================================== */
(function () {
  'use strict';

  var btn = document.getElementById('footer-rewind');
  if (!btn) return;

  var staticEl = document.getElementById('rewind-static');
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rewinding = false;

  btn.addEventListener('click', function () {
    if (rm) { window.scrollTo(0, 0); return; }
    if (rewinding) return;
    rewinding = true;

    staticEl.classList.add('is-active');

    var from = window.scrollY;
    var ms = Math.min(900, 350 + from * 0.12);
    var t0 = performance.now();

    function step(now) {
      var p = Math.min(1, (now - t0) / ms);
      var eased = 1 - Math.pow(1 - p, 3);
      window.scrollTo(0, from * (1 - eased));
      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        setTimeout(function () {
          staticEl.classList.remove('is-active');
          rewinding = false;
        }, 120);
      }
    }
    requestAnimationFrame(step);
  });
})();

/* =====================================================
   CART DRAWER — real Shopify cart (items, qty, remove,
   live subtotal, free-shipping bar + celebration)
   ===================================================== */
(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  var backdrop = document.getElementById('cart-backdrop');
  var closeBtn = document.getElementById('cart-close');
  var itemsWrap = document.getElementById('cart-items');
  var shipEl = document.getElementById('cart-ship');
  var shipMsg = document.getElementById('cart-ship-msg');
  var shipFill = document.getElementById('cart-ship-fill');
  var subtotalEl = document.getElementById('cart-subtotal');
  var drawerCount = document.getElementById('cart-drawer-count');
  var navCounts = document.querySelectorAll('#cart-count, .header-cart__count, [data-cart-count]');
  var threshold = (parseFloat(shipEl && shipEl.getAttribute('data-threshold')) || 65) * 100;
  var wasUnlocked = false;
  var FLAVORS = { 'pb-maxd-10oz': '#E63B2E', '90s-crisps': '#2E6BE6', 'cowabunga-pies-1': '#7BC74D', 'nuttyfinger-bbs-10oz': '#1F2A63', 'lunch-box-granola-bar-10oz': '#FFC42E', 'pb-banana-creme': '#7A3DB8', '35-lb-bucket-90s-crisps': '#1F52B8', 'bubble-nutty-cotton-candy': '#F49CC4', 'banana-look-alikes': '#F6D64A', 'peanut-butter-bites': '#F1901C', 'homeys-dohnut-10oz': '#F0619E', 'cartoon-dinosaur-bar': '#7BC74D', 'copy-of-nuttyfinger-ice-cream-bar-drops-04-05': '#2E6BE6', '90-s-dunkers-10oz': '#8A5CC7', '90s-fancy-ice-cream': '#C9A227', 'deep-fried-cookie-sandwich': '#2A4FC8', 'crispy-treats-cereal': '#F26A21', 'devils-food-cake-cookie': '#6E7A2E', 'nutty-pops-choc-vanilla-swirl': '#E8951F', '80s-birthday-party': '#6E3FA8', 'smores-funnel-cake': '#D23C28', 'fun-nel-house-of-horror': '#E0506A', 'copy-of-homeys-dohnut-restocks-04-05': '#2A54C8', 'ecto-nutty-10oz': '#5FA02E', 'free-mystery-jar': '#8A4FC0', 'smores-candy-bar': '#5A3418', 'cookie-butter-bar': '#D68F2E', 'imaginary-pie-cereal-milk-cream-pie': '#1E8E7E', 'matilda-cake': '#A8202E', 'nuttyfinger-ice-cream-bar': '#E8721C', '90s-schwag': '#7FA02E', 'mystery-flavor': '#211C18' };
  var JARS = { '90s-crisps': NN_ASSET_BASE + '90s-crisps-transparent.png', 'pb-maxd-10oz': NN_ASSET_BASE + 'pb-max-d-transparent.png', 'cowabunga-pies-1': NN_ASSET_BASE + 'cowabunga-pies-transparent.png', 'nuttyfinger-bbs-10oz': NN_ASSET_BASE + 'nuttyfinger-bbs-transparent.png', 'lunch-box-granola-bar-10oz': NN_ASSET_BASE + 'granola-bar-transparent.png', 'pb-banana-creme': NN_ASSET_BASE + 'the-king-pb-banana-creme.png', '35-lb-bucket-90s-crisps': NN_ASSET_BASE + '35lb-90s-crisps.png', 'bubble-nutty-cotton-candy': NN_ASSET_BASE + 'bubble-nutty.png', 'banana-look-alikes': NN_ASSET_BASE + 'banana-look-alikes.png', 'peanut-butter-bites': NN_ASSET_BASE + 'peanut-butter-bites.png', 'homeys-dohnut-10oz': NN_ASSET_BASE + 'homeys-dohnut.png', 'cartoon-dinosaur-bar': NN_ASSET_BASE + 'cartoon-dinosaur-bar.png', 'copy-of-nuttyfinger-ice-cream-bar-drops-04-05': NN_ASSET_BASE + 'me-eat-cookies.png', '90-s-dunkers-10oz': NN_ASSET_BASE + '90s-dunkers.png', '90s-fancy-ice-cream': NN_ASSET_BASE + '90s-fancy-ice-cream.png', 'deep-fried-cookie-sandwich': NN_ASSET_BASE + 'deep-fried-sandwich-cookie.png', 'crispy-treats-cereal': NN_ASSET_BASE + 'crispy-treats.png', 'devils-food-cake-cookie': NN_ASSET_BASE + 'devils-food-cake.png', 'nutty-pops-choc-vanilla-swirl': NN_ASSET_BASE + 'nutty-pops.png', '80s-birthday-party': NN_ASSET_BASE + '80s-birthday-party.png', 'smores-funnel-cake': NN_ASSET_BASE + 'smores-funnel-cake.png', 'fun-nel-house-of-horror': NN_ASSET_BASE + 'strawberry-funnel-cake.png', 'copy-of-homeys-dohnut-restocks-04-05': NN_ASSET_BASE + 'friday-night-in-the-90s.png', 'ecto-nutty-10oz': NN_ASSET_BASE + 'ecto-nutty.png', 'free-mystery-jar': NN_ASSET_BASE + 'fruity-cereal-sandwich-cookie.png', 'smores-candy-bar': NN_ASSET_BASE + 'smores-candy-bar.png', 'cookie-butter-bar': NN_ASSET_BASE + 'cookie-butter-bar.png', 'imaginary-pie-cereal-milk-cream-pie': NN_ASSET_BASE + 'imaginary-pie.png', 'matilda-cake': NN_ASSET_BASE + 'matilda-cake.png', 'nuttyfinger-ice-cream-bar': NN_ASSET_BASE + 'nuttyfinger-ice-cream-bar.png', '90s-schwag': NN_ASSET_BASE + '90s-Schwag.png', 'mystery-flavor': NN_ASSET_BASE + 'mystery-flavor.png' };
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function spawnConfetti() {
    if (reduceMotion || !shipEl) return;
    var colors = ['#F5E6C8', '#FFC42E', '#2E6BE6', '#7BC74D', '#E63B2E', '#ffffff', '#54c8d6'];
    var layer = document.createElement('div');
    layer.className = 'cart-confetti';
    layer.style.top = (shipEl.offsetTop + shipEl.offsetHeight / 2) + 'px';
    for (var i = 0; i < 24; i++) {
      var bit = document.createElement('span');
      var t = Math.random();
      var kind = t < 0.62 ? 'chip' : (t < 0.82 ? 'tri' : 'star');
      bit.className = 'cart-confetti__bit cart-confetti__bit--' + kind;
      if (kind === 'chip') { bit.style.background = colors[i % colors.length]; }
      else { bit.textContent = kind === 'tri' ? '▶' : '★'; bit.style.color = (i % 2) ? '#FFC42E' : '#E63B2E'; }
      bit.style.setProperty('--dx', ((Math.random() * 2 - 1) * 155).toFixed(0) + 'px');
      bit.style.setProperty('--spin', ((Math.random() * 2 - 1) * 540).toFixed(0) + 'deg');
      bit.style.animationDelay = (Math.random() * 0.09).toFixed(3) + 's';
      layer.appendChild(bit);
    }
    shipEl.parentNode.appendChild(layer);
    setTimeout(function () { layer.remove(); }, 1700);
  }
  function lineHtml(item) {
    var hex = FLAVORS[item.handle] || '#8A867E';
    return '<div class="cart-item" data-key="' + esc(item.key) + '" style="--flavor:' + hex + '">' +
      '<img class="cart-item__jar" src="' + esc(JARS[item.handle] || item.image || '') + '" alt="' + esc(item.product_title) + '" width="120" height="120">' +
      '<div class="cart-item__info">' +
        '<span class="cart-item__name">' + esc(item.product_title) + '</span>' +
        '<span class="cart-item__variant">' + esc(item.variant_title || '16 oz jar') + '</span>' +
        '<div class="cart-qty" role="group" aria-label="Quantity">' +
          '<button type="button" class="cart-qty__btn" data-step="-1" aria-label="Decrease quantity">−</button>' +
          '<span class="cart-qty__n">' + item.quantity + '</span>' +
          '<button type="button" class="cart-qty__btn" data-step="1" aria-label="Increase quantity">+</button>' +
        '</div>' +
      '</div>' +
      '<div class="cart-item__right">' +
        '<span class="cart-item__price">' + money(item.final_line_price) + '</span>' +
        '<button type="button" class="cart-item__remove" aria-label="Remove item">REMOVE</button>' +
      '</div>' +
    '</div>';
  }
  function render(cart) {
    if (itemsWrap) {
      itemsWrap.innerHTML = cart.items.length
        ? cart.items.map(lineHtml).join('')
        : '<div class="cart-empty"><span class="cart-empty__bars" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i><i></i></span><p class="cart-empty__head">NOTHING&rsquo;S QUEUED UP YET</p><p class="cart-empty__sub">Your cart&rsquo;s running on dead air. Let&rsquo;s fix that.</p><a href="/collections/all" class="btn btn--primary cart-empty__cta">SHOP THE DROP</a></div>';
    }
    var count = cart.item_count, subtotal = cart.total_price;
    if (subtotalEl) subtotalEl.textContent = money(subtotal);
    if (drawerCount) drawerCount.textContent = count;
    navCounts.forEach(function (el) { el.textContent = count; });
    if (shipEl) shipEl.style.display = count ? '' : 'none';
    var _up = drawer.querySelector('.cart-upsell'); var _ft = drawer.querySelector('.cart-foot');
    if (_up) _up.style.display = count ? '' : 'none';
    if (_ft) _ft.style.display = count ? '' : 'none';
    if (shipFill) shipFill.style.width = Math.min(100, (subtotal / threshold) * 100) + '%';
    var unit = cart.items.length ? Math.min.apply(null, cart.items.map(function (i) { return i.final_price; })) : 1499;
    var unlocked = subtotal >= threshold;
    if (shipMsg) {
      if (unlocked) {
        shipMsg.innerHTML = '★ FREE SHIPPING UNLOCKED ★';
        if (!wasUnlocked) { shipEl.classList.remove('is-unlocked'); void shipEl.offsetWidth; shipEl.classList.add('is-unlocked'); spawnConfetti(); }
      } else {
        var left = threshold - subtotal; var jars = Math.max(1, Math.ceil(left / unit)); shipMsg.innerHTML = "You're <strong>" + money(left) + "</strong> away — add " + jars + " more jar" + (jars === 1 ? "" : "s") + " for FREE shipping";
        if (shipEl) shipEl.classList.remove('is-unlocked');
      }
    }
    wasUnlocked = unlocked;
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }); }
  function change(key, qty) { return post('/cart/update.js', { updates: (function () { var u = {}; u[key] = qty; return u; })() }).then(function (r) { return r.json(); }).then(render); }
  function add(id, qty) { return post('/cart/add.js', { id: id, quantity: qty || 1 }).then(function (r) { if (!r.ok) throw new Error('add'); return getCart(); }).then(function (c) { render(c); return c; }); }
  function openCart() { drawer.classList.add('is-open'); if (backdrop) backdrop.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeCart() { drawer.classList.remove('is-open'); if (backdrop) backdrop.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  document.querySelectorAll('.header-cart').forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (backdrop) backdrop.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCart(); });
  if (itemsWrap) itemsWrap.addEventListener('click', function (e) {
    var item = e.target.closest('.cart-item'); if (!item) return;
    var key = item.getAttribute('data-key');
    var step = e.target.closest('.cart-qty__btn');
    if (step) { var cur = parseInt(item.querySelector('.cart-qty__n').textContent, 10) || 0; change(key, Math.max(0, cur + parseInt(step.getAttribute('data-step'), 10))); return; }
    if (e.target.closest('.cart-item__remove')) { change(key, 0); }
  });
  document.querySelectorAll('.cart-add').forEach(function (btn) {
    btn.addEventListener('click', function () { var vid = btn.getAttribute('data-variant-id'); if (vid) add(vid, 1); });
  });
  document.querySelectorAll('.drop-card__btn').forEach(function (btn) {
    if (btn.closest('.notify-card')) return; // Get Notified cards are links to product pages — let them navigate
    if (btn.classList.contains('drop-card__btn--soldout')) return; // sold-out cards link to the PDP (Kbite notify lives there)
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var card = btn.closest('.drop-card');
      var link = card ? card.querySelector('.drop-card__link') : null;
      var m = (link ? link.getAttribute('href') || '' : '').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var label = btn.textContent; btn.disabled = true; btn.textContent = 'ADDING…';
      fetch('/products/' + m[1] + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) { var av = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0]; if (!av) throw new Error('novariant'); return add(av.id, 1); })
        .then(function () { openCart(); btn.textContent = 'ADDED ✓'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1500); })
        .catch(function () { btn.textContent = 'ERROR'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1500); });
    });
  });
  window.NNCart = {
    open: openCart, close: closeCart,
    refresh: function () { return getCart().then(render); },
    add: function (id, qty) { return add(id, qty); },
    addAndOpen: function (id, qty) { return add(id, qty).then(function (c) { openCart(); return c; }); }
  };
  getCart().then(render);
})();

/* ---- Reviews testimonial reel (broadcast-style cycle) ---- */
(function () {
  var reel = document.getElementById('rev-reel');
  if (!reel) return;
  var slides = Array.prototype.slice.call(reel.querySelectorAll('.ugc__tm'));
  if (slides.length < 2) return;
  var staticEl = document.getElementById('rev-static');
  var chEl = document.getElementById('rev-ch');
  var prev = document.getElementById('rev-prev');
  var next = document.getElementById('rev-next');
  var i = 0;
  var timer;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show(n) {
    i = (n + slides.length) % slides.length;
    slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
    if (chEl) chEl.textContent = 'CH ' + (slides[i].getAttribute('data-ch') || ('0' + (i + 1)));
    if (staticEl && !reduce) {
      staticEl.classList.add('is-cut');
      setTimeout(function () { staticEl.classList.remove('is-cut'); }, 160);
    }
  }
  function go(n) { show(n); restart(); }
  function restart() { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, 5000); }

  if (next) next.addEventListener('click', function () { go(i + 1); });
  if (prev) prev.addEventListener('click', function () { go(i - 1); });
  reel.addEventListener('mouseenter', function () { clearInterval(timer); });
  reel.addEventListener('mouseleave', restart);
  restart();
})();

/* ---- Get Notified — channel tuner: jump-tabs, scroll-spy, channel-change FX ---- */
(function () {
  var tabsNav = document.querySelector('.notify-tabs');
  if (!tabsNav) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tabs = Array.prototype.slice.call(tabsNav.querySelectorAll('.notify-tab'));
  var osd = document.getElementById('notify-osd');
  var snow = document.getElementById('notify-static');
  var snowTimer, osdTimer;

  function setActive(id) {
    tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('href') === id); });
  }

  function channelChange(tab) {
    if (reduce) return;
    if (snow) {
      snow.classList.remove('is-on');
      void snow.offsetWidth; // restart the burst
      snow.classList.add('is-on');
      clearTimeout(snowTimer);
      snowTimer = setTimeout(function () { snow.classList.remove('is-on'); }, 320);
    }
    if (osd) {
      var chEl = osd.querySelector('.notify-osd__ch');
      var nameEl = osd.querySelector('.notify-osd__name');
      if (chEl) chEl.textContent = tab.getAttribute('data-ch') || '';
      if (nameEl) nameEl.textContent = tab.getAttribute('data-name') || '';
      osd.classList.remove('is-on');
      void osd.offsetWidth;
      osd.classList.add('is-on');
      clearTimeout(osdTimer);
      osdTimer = setTimeout(function () { osd.classList.remove('is-on'); }, 1650);
    }
  }

  tabsNav.addEventListener('click', function (e) {
    var a = e.target.closest('.notify-tab');
    if (!a) return;
    var id = a.getAttribute('href');
    if (!id || id.charAt(0) !== '#') return;
    var target = document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    setActive(id);
    channelChange(a);
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', id);
  });

  if (tabs[0]) setActive(tabs[0].getAttribute('href'));

  // Scroll-spy: light the channel whose section is in view
  if ('IntersectionObserver' in window) {
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) setActive('#' + en.target.id);
      });
    }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
    Array.prototype.forEach.call(document.querySelectorAll('.notify-cat'), function (c) { spy.observe(c); });
  }
})();

/* ---- Get Notified — live search (OSD tuner readout + filter, hide empty channels) ---- */
(function () {
  var input = document.getElementById('notify-search');
  if (!input) return;
  var screen = input.closest('.notify-search');
  var cats = Array.prototype.slice.call(document.querySelectorAll('.notify-cat'));
  var cards = Array.prototype.slice.call(document.querySelectorAll('.notify-card'));
  var noResults = document.getElementById('notify-noresults');
  var readout = document.getElementById('notify-readout');
  var total = cards.length;

  function setReadout(q, count) {
    if (!readout) return;
    if (!q) { readout.textContent = total + ' FLAVORS'; readout.classList.remove('is-nosignal'); }
    else if (count === 0) { readout.textContent = 'NO SIGNAL'; readout.classList.add('is-nosignal'); }
    else { readout.textContent = count + ' FOUND'; readout.classList.remove('is-nosignal'); }
  }

  input.addEventListener('input', function () {
    var q = input.value.trim().toLowerCase();
    var count = 0;

    cards.forEach(function (card) {
      var nameEl = card.querySelector('.drop-card__name');
      var name = nameEl ? nameEl.textContent.toLowerCase() : '';
      var match = !q || name.indexOf(q) !== -1;
      card.classList.toggle('is-hidden', !match);
      if (match) count++;
    });

    cats.forEach(function (cat) {
      var hasVisible = cat.querySelector('.notify-card:not(.is-hidden)');
      cat.classList.toggle('is-hidden', !hasVisible);
    });

    if (noResults) noResults.hidden = !(q && count === 0);
    if (screen) screen.classList.toggle('is-typing', q.length > 0);
    setReadout(q, count);
  });

  setReadout('', total);
})();

/* ---- Reviews — ratings-board power-on (VU sweep + count-up + star flicker) ---- */
(function () {
  var panel = document.querySelector('.rv-summary__panel');
  if (!panel) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) { panel.classList.remove('is-armed'); return; }

  var avg = document.getElementById('rv-avg');
  if (avg) avg.textContent = '0.00';

  var played = false;
  function play() {
    if (played) return;
    played = true;
    panel.classList.remove('is-armed');
    panel.classList.add('is-on');
    if (!avg) return;
    var target = parseFloat(avg.getAttribute('data-count')) || 0;
    var start = null, dur = 1050;
    function tick(t) {
      if (start === null) start = t;
      var p = Math.min((t - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      avg.textContent = (eased * target).toFixed(2);
      if (p < 1) requestAnimationFrame(tick); else avg.textContent = target.toFixed(2);
    }
    requestAnimationFrame(tick);
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { play(); io.disconnect(); } });
    }, { threshold: 0.35 });
    io.observe(panel);
  } else {
    play();
  }
})();

/* ---- Reviews — per-flavor carousels + sticky flavor jump-nav scrollspy ---- */
(function () {
  var nav = document.getElementById('rv-flavornav');
  if (!nav) return;

  // Carousel arrows (desktop). Mobile uses native swipe.
  var carousels = document.querySelectorAll('.rv-carousel');
  Array.prototype.forEach.call(carousels, function (car) {
    var track = car.querySelector('.rv-car__track');
    var prev = car.querySelector('.rv-car__nav--prev');
    var next = car.querySelector('.rv-car__nav--next');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector('.rv-card');
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  // Scrollspy — light up the chip whose flavor section is in view.
  var chips = Array.prototype.slice.call(nav.querySelectorAll('.rv-fchip'));
  function setActive(id) {
    chips.forEach(function (c) {
      c.classList.toggle('is-active', c.getAttribute('href') === '#' + id);
    });
  }
  if ('IntersectionObserver' in window) {
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) setActive(en.target.id); });
    }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
    chips.forEach(function (c) {
      var sec = document.querySelector(c.getAttribute('href'));
      if (sec) spy.observe(sec);
    });
  }
  if (chips[0]) chips[0].classList.add('is-active');
})();

/* ---- Reviews — "Read more" modal for clamped cards ---- */
(function () {
  var modal = document.getElementById('rv-modal');
  if (!modal) return;
  var mStars = document.getElementById('rv-modal-stars');
  var mTitle = document.getElementById('rv-modal-title');
  var mQuote = document.getElementById('rv-modal-quote');
  var mJar = document.getElementById('rv-modal-jar');
  var mName = document.getElementById('rv-modal-name');
  var mFlavor = document.getElementById('rv-modal-flavor');
  var lastFocus = null;

  function openModal(card) {
    var stars = card.querySelector('.rv-card__stars');
    var title = card.querySelector('.rv-card__title');
    var quote = card.querySelector('.rv-card__quote');
    var jar = card.querySelector('.rv-card__jar');
    var name = card.querySelector('.rv-card__name');
    var section = card.closest('.rv-flavor');
    var fname = section ? section.querySelector('.rv-flavor__name') : null;

    mStars.innerHTML = stars ? stars.innerHTML : '';
    mTitle.textContent = title ? title.textContent : '';
    mQuote.innerHTML = quote ? quote.innerHTML : '';
    mJar.src = jar ? jar.src : '';
    mName.textContent = name ? name.textContent : '';
    mFlavor.textContent = fname ? fname.textContent : '';

    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.getElementById('rv-modal-close').focus();
  }
  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  modal.addEventListener('click', function (e) {
    if (e.target.hasAttribute('data-rv-close') || e.target.id === 'rv-modal-close') closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  // Add "Read more" only to cards whose body actually overflows the clamp.
  var cards = document.querySelectorAll('.rv-car__track > .rv-card:not(.rv-card--cta)');
  Array.prototype.forEach.call(cards, function (card) {
    var quote = card.querySelector('.rv-card__quote');
    if (!quote) return;
    if (quote.scrollHeight - quote.clientHeight > 2) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rv-card__more';
      btn.textContent = 'READ MORE ▸';
      quote.insertAdjacentElement('afterend', btn);
      btn.addEventListener('click', function () { openModal(card); });
    }
  });
})();

/* ---- Time Capsule — left-edge REWIND tab + CRT video modal (homepage) ---- */
(function () {
  var tab = document.getElementById('capsule-open');
  var modal = document.getElementById('capsule-modal');
  if (!tab || !modal) return;
  var video = document.getElementById('capsule-video');
  var staticEl = document.getElementById('capsule-static');
  var screenEl = modal.querySelector('.capsule-tv__screen');
  var closeBtn = document.getElementById('capsule-close');
  var muteBtn = document.getElementById('capsule-mute');
  var backdrop = document.getElementById('capsule-backdrop');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveal the tab once you've scrolled past the hero
  function onScroll() {
    var show = window.pageYOffset > window.innerHeight * 0.55;
    tab.classList.toggle('is-visible', show);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  function setMuteIcon() { muteBtn.innerHTML = video.muted ? '🔇' : '🔊'; }

  function open() {
    if (!video.src) video.src = video.getAttribute('data-src'); // lazy-load
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    video.currentTime = 0;
    video.muted = false;
    setMuteIcon();
    // CRT power-on: flash → static snow + sync-roll → the picture tunes in
    if (!reduce && staticEl) {
      if (screenEl) screenEl.classList.add('is-tuning');
      staticEl.classList.add('is-on');
      setTimeout(function () {
        staticEl.classList.remove('is-on');
        if (screenEl) screenEl.classList.remove('is-tuning');
      }, 1050);
    }
    var p = video.play();
    if (p && p.catch) p.catch(function () { video.muted = true; setMuteIcon(); video.play(); });
    closeBtn.focus();
  }
  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    video.pause();
    tab.focus();
  }

  tab.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  if (backdrop) backdrop.addEventListener('click', close);
  muteBtn.addEventListener('click', function () { video.muted = !video.muted; setMuteIcon(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });
  video.addEventListener('ended', close);
})();

/* ---- Nutty Hotline — launcher + call-in modal (canned-reply prototype; real bot wires in via Cloudflare embed) ---- */
(function () {
  function nnHotlineInit() {
  var openBtn = document.getElementById('nn-hotline-open');
  var modal = document.getElementById('nn-call');
  if (!openBtn || !modal) return;
  var backdrop = document.getElementById('nn-call-backdrop');
  var closeBtn = document.getElementById('nn-call-close');
  var log = document.getElementById('nn-call-log');
  var form = document.getElementById('nn-call-form');
  var input = document.getElementById('nn-call-input');
  var quick = document.getElementById('nn-call-quick');
  var greeted = false;

  // True visible viewport height — excludes mobile toolbars AND the on-screen keyboard.
  // Drives the modal's --vvh so the input bar is never clipped (the #1 mobile-modal bug).
  function setVVH() {
    var h = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
    document.documentElement.style.setProperty('--vvh', h + 'px');
  }
  setVVH();
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', setVVH);
    window.visualViewport.addEventListener('scroll', setVVH);
  } else {
    window.addEventListener('resize', setVVH);
  }

  // ---- Live bot wiring (Cloudflare Worker) ----
  var WORKER_URL = "https://designmynt-chatbot.jordyn-501.workers.dev/chat";
  var CLIENT_ID = "nutty-nostalgic";
  var GREETING = "You're through to the Nutty Hotline, operators (okay, operator) standing by. What can I get you: shipping, allergens, flavors, or Jay himself?";
  var CHIP_MSG = {
    shipping: "How does shipping work?",
    allergens: "What are the allergens?",
    flavors: "What flavors do you have?",
    human: "Can I reach Jay?"
  };
  var history = [];   // {role, content} turns sent to the worker for context
  var sending = false;
  var ended = false;

  function scrollDown() { log.scrollTop = log.scrollHeight; }
  function addMsg(who, text, cls) {
    var wrap = document.createElement('div');
    wrap.className = 'nn-msg ' + cls;
    var w = document.createElement('div'); w.className = 'nn-msg__who'; w.textContent = who;
    var b = document.createElement('div'); b.className = 'nn-msg__bubble'; b.textContent = text;
    wrap.appendChild(w); wrap.appendChild(b); log.appendChild(wrap); scrollDown();
  }

  // ---- Rich operator replies: safe links + product cards + follow-up chips ----
  function fmtPrice(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  function safeUrl(u) { return /^(https?:\/\/|\/)[^\s]*$/.test(u) ? u : null; } // only http(s) or root-relative
  // Render plain text into `parent`, turning [label](url) and bare URLs into real anchors (DOM-built, never innerHTML).
  function appendLinked(parent, text) {
    var re = /\[([^\]]+)\]\((https?:\/\/[^\s)]+|\/[^\s)]+)\)|(https?:\/\/[^\s]+)/g;
    var last = 0, m;
    while ((m = re.exec(text))) {
      if (m.index > last) parent.appendChild(document.createTextNode(text.slice(last, m.index)));
      var label = m[1] || m[3], url = safeUrl(m[2] || m[3]);
      if (url) {
        var a = document.createElement('a');
        a.className = 'nn-link'; a.href = url; a.textContent = label;
        if (/^https?:/.test(url)) { a.target = '_blank'; a.rel = 'noopener'; }
        parent.appendChild(a);
      } else { parent.appendChild(document.createTextNode(m[0])); }
      last = re.lastIndex;
    }
    if (last < text.length) parent.appendChild(document.createTextNode(text.slice(last)));
  }
  // Transparent jar PNGs (match the rest of the site) — used on cards instead of the Shopify product photo.
  var CARD_IMG = {
    'imaginary-pie-cereal-milk-cream-pie': NN_ASSET_BASE + 'imaginary-pie.png',
    'matilda-cake': NN_ASSET_BASE + 'matilda-cake.png',
    'nuttyfinger-ice-cream-bar': NN_ASSET_BASE + 'nuttyfinger-ice-cream-bar.png',
    '90s-schwag': NN_ASSET_BASE + '90s-Schwag.png',
    'mystery-flavor': NN_ASSET_BASE + 'mystery-flavor.png',
    'pb-maxd-10oz': NN_ASSET_BASE + 'pb-max-d-transparent.png',
    '90s-crisps': NN_ASSET_BASE + '90s-crisps-transparent.png',
    'cowabunga-pies-1': NN_ASSET_BASE + 'cowabunga-pies-transparent.png',
    'nuttyfinger-bbs-10oz': NN_ASSET_BASE + 'nuttyfinger-bbs-transparent.png',
    'lunch-box-granola-bar-10oz': NN_ASSET_BASE + 'granola-bar-transparent.png',
    'pb-banana-creme': NN_ASSET_BASE + 'the-king-pb-banana-creme.png',
    '35-lb-bucket-90s-crisps': NN_ASSET_BASE + '35lb-90s-crisps.png',
    'bubble-nutty-cotton-candy': NN_ASSET_BASE + 'bubble-nutty.png',
    'banana-look-alikes': NN_ASSET_BASE + 'banana-look-alikes.png',
    'peanut-butter-bites': NN_ASSET_BASE + 'peanut-butter-bites.png',
    'homeys-dohnut-10oz': NN_ASSET_BASE + 'homeys-dohnut.png',
    'cartoon-dinosaur-bar': NN_ASSET_BASE + 'cartoon-dinosaur-bar.png',
    'copy-of-nuttyfinger-ice-cream-bar-drops-04-05': NN_ASSET_BASE + 'me-eat-cookies.png',
    '90-s-dunkers-10oz': NN_ASSET_BASE + '90s-dunkers.png',
    '90s-fancy-ice-cream': NN_ASSET_BASE + '90s-fancy-ice-cream.png',
    'deep-fried-cookie-sandwich': NN_ASSET_BASE + 'deep-fried-sandwich-cookie.png',
    'crispy-treats-cereal': NN_ASSET_BASE + 'crispy-treats.png',
    'devils-food-cake-cookie': NN_ASSET_BASE + 'devils-food-cake.png',
    'nutty-pops-choc-vanilla-swirl': NN_ASSET_BASE + 'nutty-pops.png',
    '80s-birthday-party': NN_ASSET_BASE + '80s-birthday-party.png',
    'smores-funnel-cake': NN_ASSET_BASE + 'smores-funnel-cake.png'
  };
  // Product card from a handle: image, name, price, View link + Add-to-cart (only if a variant is in stock).
  function buildCard(handle) {
    var card = document.createElement('div'); card.className = 'nn-card'; card.textContent = '…';
    fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        card.textContent = '';
        var img = document.createElement('img'); img.className = 'nn-card__img';
        img.src = CARD_IMG[handle] || p.featured_image || (p.images && p.images[0]) || ''; img.alt = p.title || ''; img.loading = 'lazy';
        var info = document.createElement('div'); info.className = 'nn-card__info';
        var name = document.createElement('a'); name.className = 'nn-card__name'; name.href = '/products/' + handle; name.textContent = p.title || '';
        var price = document.createElement('span'); price.className = 'nn-card__price'; price.textContent = fmtPrice(p.price);
        var btns = document.createElement('div'); btns.className = 'nn-card__btns';
        var av = (p.variants || []).filter(function (v) { return v.available; })[0];
        if (av) {
          var addBtn = document.createElement('button'); addBtn.type = 'button'; addBtn.className = 'nn-card__add'; addBtn.textContent = 'ADD TO CART';
          addBtn.addEventListener('click', function () {
            addBtn.disabled = true; addBtn.textContent = 'ADDING…';
            var pr = (window.NNCart && window.NNCart.addAndOpen) ? window.NNCart.addAndOpen(av.id, 1)
              : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: av.id, quantity: 1 }) });
            Promise.resolve(pr).then(function () { addBtn.textContent = 'ADDED ✓'; }).catch(function () { addBtn.textContent = 'ERROR'; addBtn.disabled = false; });
          });
          btns.appendChild(addBtn);
        }
        var view = document.createElement('a'); view.className = 'nn-card__view'; view.href = '/products/' + handle; view.textContent = av ? 'View' : 'View flavor';
        btns.appendChild(view);
        info.appendChild(name); info.appendChild(price); info.appendChild(btns);
        card.appendChild(img); card.appendChild(info); scrollDown();
      })
      .catch(function () { if (card.parentNode) card.parentNode.removeChild(card); }); // drop a broken card silently
    return card;
  }
  function addChips(labels) {
    if (!labels.length) return;
    var row = document.createElement('div'); row.className = 'nn-chips';
    labels.forEach(function (lbl) {
      var c = document.createElement('button'); c.type = 'button'; c.className = 'nn-chip'; c.textContent = lbl;
      c.addEventListener('click', function () { row.querySelectorAll('.nn-chip').forEach(function (x) { x.disabled = true; }); sendToBot(lbl); });
      row.appendChild(c);
    });
    log.appendChild(row); scrollDown();
  }
  function operatorMsg(text) {
    history.push({ role: 'assistant', content: text }); // keep RAW (markers included) for the bot's context
    var cards = [], chips = [];
    var clean = text.replace(/\[\[card:([^\]|]+)\]\]/g, function (_, h) { cards.push(h.trim()); return ''; });
    clean = clean.replace(/\[\[chips:([^\]]+)\]\]/g, function (_, c) { chips = c.split('|').map(function (s) { return s.trim(); }).filter(Boolean); return ''; });
    clean = clean.replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
    if (clean) {
      var wrap = document.createElement('div'); wrap.className = 'nn-msg nn-msg--op';
      var av = document.createElement('img'); av.className = 'nn-msg__avatar'; av.src = 'https://i.ibb.co/YBwBL5pX/NN-logo-chatbot.png'; av.alt = '';
      var right = document.createElement('div'); right.className = 'nn-msg__right';
      var w = document.createElement('div'); w.className = 'nn-msg__who'; w.textContent = 'OPERATOR';
      var b = document.createElement('div'); b.className = 'nn-msg__bubble'; appendLinked(b, clean);
      right.appendChild(w); right.appendChild(b);
      wrap.appendChild(av); wrap.appendChild(right); log.appendChild(wrap);
    }
    cards.forEach(function (h) { log.appendChild(buildCard(h)); });
    addChips(chips);
    scrollDown();
  }
  function showTyping() {
    var t = document.createElement('div');
    t.className = 'nn-msg nn-msg--op nn-typing';
    t.innerHTML = '<img class="nn-msg__avatar" src="https://i.ibb.co/YBwBL5pX/NN-logo-chatbot.png" alt=""><div class="nn-msg__right"><div class="nn-msg__who">OPERATOR</div><div class="nn-msg__bubble"><span></span><span></span><span></span></div></div>';
    log.appendChild(t); scrollDown();
    return t;
  }
  function sendToBot(text) {
    if (sending || ended || !text) return;
    sending = true;
    addMsg('YOU', text, 'nn-msg--me');
    history.push({ role: 'user', content: text });
    var typing = showTyping();
    fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ clientId: CLIENT_ID, message: text, history: history.slice(0, -1) })
    }).then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (data) {
        if (typing.parentNode) log.removeChild(typing);
        sending = false;
        var meta = (data && data.meta) || {};
        if (meta.leadCapture) {
          operatorMsg("Best bet is to text or call us at 954-275-6577, or email jay@nuttynostalgic.com — a real human jumps on it, 8 to 8 Eastern.");
        } else {
          operatorMsg((data && data.reply) || "Sorry caller, didn't catch that — try me again?");
        }
        if (meta.sessionEnded) {
          ended = true;
          if (input) { input.disabled = true; input.placeholder = "Call ended — refresh to start over"; }
        }
      })
      .catch(function () {
        if (typing.parentNode) log.removeChild(typing);
        sending = false;
        operatorMsg("Hotline's a little fuzzy right now — text us at 954-275-6577 and a human will jump on it.");
      });
  }
  function openModal() {
    if (backdrop) backdrop.classList.add('is-open');
    modal.classList.add('is-open', 'is-connecting');
    modal.setAttribute('aria-hidden', 'false');
    openBtn.classList.add('is-read');
    setTimeout(function () { modal.classList.remove('is-connecting'); }, 460);
    if (!greeted) {
      greeted = true;
      setTimeout(function () { operatorMsg(GREETING); }, 380);
    }
    if (input && !ended) setTimeout(function () { input.focus(); }, 240);
  }
  function closeModal() {
    if (backdrop) backdrop.classList.remove('is-open');
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    openBtn.focus();
  }
  openBtn.addEventListener('click', openModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (backdrop) backdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(); });
  if (quick) quick.addEventListener('click', function (e) {
    var chip = e.target.closest('.nn-call__chip'); if (!chip) return;
    sendToBot(CHIP_MSG[chip.getAttribute('data-ask')] || chip.textContent.trim());
  });
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var val = input.value.trim(); if (!val) return;
    input.value = '';
    sendToBot(val);
  });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', nnHotlineInit); } else { nnHotlineInit(); }
})();